import { Cirus } from "@/classes/Http";
class Permission {
    query: boolean;
    command: boolean;
    dangerousCommand: boolean;
}

export class InstanceAccess {
    inventory: Permission;
    boughtTransaction: Permission;
    soldTransaction: Permission;
    incomeTransaction: Permission;
    costTransaction: Permission;
    returnSoldTransaction: Permission;
    returnBoughtTransaction: Permission;
    transferTransaction: Permission;
    boughtInvoice: Permission;
    soldInvoice: Permission;
    incomeInvoice: Permission;
    costInvoice: Permission;
    returnSoldInvoice: Permission;
    returnBoughtInvoice: Permission;
    transferInvoice: Permission;
    customer: Permission;
    crm: Permission;
    insight: Permission;
    media: Permission;
    setting: Permission;
}

export class setUserPermissionsRequest {
    id: string;
    permissions: InstanceAccess;
}

export function setUserPermissions (instance_id: number, body: setUserPermissionsRequest) {
    const query = `/instance/${instance_id}/user/permissions`;
    return Cirus.post(query, body);
}